import { QuoteRequestRepository } from "./types";

const quoteRequests = [
  { id: "quote-001", customerName: "Van der Meer Trading", pol: "Rotterdam", pod: "Shanghai", etd: "2026-10-03", eta: "2026-11-08" },
  { id: "quote-002", customerName: "North Sea Foods", pol: "Antwerpen", pod: "Singapore", etd: "2026-10-06", eta: "2026-11-02" },
  { id: "quote-003", customerName: "Delta Machinery", pol: "Hamburg", pod: "Jebel Ali", etd: "2026-10-09", eta: "2026-10-31" },
  { id: "quote-004", customerName: "Holland Fresh Export", pol: "Rotterdam", pod: "New York", etd: "2026-10-12", eta: "2026-10-25" },
  { id: "quote-005", customerName: "Atlas Components", pol: "Antwerpen", pod: "Ningbo", etd: "2026-10-15", eta: "2026-11-20" },
];

export const mockQuoteRequestRepository: QuoteRequestRepository = {
  async getAll() {
    await new Promise(resolve => window.setTimeout(resolve, 250));
    return quoteRequests;
  },
};
